var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0625 3.0625H3.9375C3.45352 3.0625 3.0625 3.45352 3.0625 3.9375V24.0625C3.0625 24.5465 3.45352 24.9375 3.9375 24.9375H24.0625C24.5465 24.9375 24.9375 24.5465 24.9375 24.0625V3.9375C24.9375 3.45352 24.5465 3.0625 24.0625 3.0625ZM23.1875 23.1875H18.1535V16.4664H20.9973L21.4238 13.166H18.1535V11.0578C18.1535 10.1008 18.4187 9.45 19.7887 9.45H21.5359V6.49688C21.2324 6.45586 20.1961 6.36563 18.9875 6.36563C16.4664 6.36563 14.741 7.90508 14.741 10.7297V13.1633H11.8918V16.4637H14.7438V23.1875H4.8125V4.8125H23.1875V23.1875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.6dfcc056a0337017c8bfed55fe130c2b.svg";
export { ForwardRef as ReactComponent };